import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
export default function AddMailboxAccount({ action, variables, setOpenVariable }) {
    const { t } = useTranslation();
    const label = "CONTENT.CONFIGURATION-FORM.EWS.";

    return (
        <div>
            <div className="form-element">
                {t(label + "LOGON-NAME")} / ({t(label + "USERNAME")})
                <TextInput
                    action={action}
                    inputName="logonName"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={true}
                />
                <small>test@autommate.com</small>
            </div>
            <div className="form-element">
                {t(label + "NAME")}
                <TextInput
                    action={action}
                    inputName="name"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                />
            </div>

            <div className="form-element">
                {t(label + "PASSWORD")}
                <TextInput
                    action={action}
                    inputName="password"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                />
            </div>
            <div className="form-element">
                {t(label + "DATABASE")}
                <TextInput
                    action={action}
                    inputName="database"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                />
            </div>
            <div className="form-element">
                {t(label + "FIRST-NAME")}
                <TextInput
                    action={action}
                    inputName="firstName"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                />
            </div>
            <div className="form-element">
                {t(label + "LAST-NAME")}
                <TextInput
                    action={action}
                    inputName="lastName"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                />
            </div>
            <div className="form-element">
                {t(label + "DISPLAY-NAME")}
                <TextInput
                    action={action}
                    inputName="displayName"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired
                />
            </div>
            <div className="form-element">
                {t(label + "OU")}
                <TextInput
                    action={action}
                    inputName="ou"
                    variables={variables}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                />
                <small>autommate.com/Users</small>
            </div>

        </div>
    );
}

